var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.01 13.693l.642-2.142c.12-.404.34-.77.636-1.068l8.156-8.168a.317.317 0 01.449 0l1.773 1.777a.318.318 0 010 .45l-8.154 8.167a2.542 2.542 0 01-1.068.639l-2.137.642a.238.238 0 01-.297-.297zM12.828.28l.874.874c.37.371.37.973 0 1.344l-1.065 1.066a.316.316 0 01-.447 0l-1.768-1.77a.317.317 0 010-.45L11.486.279a.948.948 0 011.342 0z",
    fill: "#9BADBC",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default ForwardRef;